import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// ==============================|| NAVIGATION - SCROLL TO TOP ||============================== //

const ScrollTop = ({ children }) => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const { pathname } = location;

  useEffect(() => {
    if (navigationType === 'POP') {
      return;
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [navigationType, pathname]);

  return children || null;
};

ScrollTop.propTypes = {
  children: PropTypes.node
};

export default ScrollTop;
